import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { getGuardianStudentSchedule } from "actions/guardians";
import Modal from "containers/Modals/Modal";
import SingleModalLesson from "containers/Lesson/SingleModal";
import SelectionDisplay from "./Partials/SelectionDisplay";
import ItemContent from "./Partials/ItemContent";
import { translate as getTranslate, getActiveLanguage } from "@haldor/ui";
import "./_Schedule.scss";
import { useMemo } from "react";
var MonthHeader = function MonthHeader(_ref) {
  var label = _ref.label;
  var test = moment().local().format("dddd");
  return /*#__PURE__*/React.createElement("span", {
    role: "columnheader",
    "aria-sort": "none",
    className: test == label.toLowerCase() ? "todaysMonth" : ""
  }, label);
};
var formats = {
  weekdayFormat: function weekdayFormat(date, culture, localizer) {
    return localizer.format(date, "dddd", culture);
  }
};
var filterMonth = function filterMonth(data, date) {
  var groups = {};
  var start = moment(date).startOf("month").set({
    hour: 0,
    minute: 0,
    second: 0
  }).toISOString();
  data.map(function (item) {
    var date = moment(item.startTime).startOf("day").toISOString();
    if (date >= start) {
      if (date in groups) {
        groups[date].push(item);
      } else {
        groups[date] = new Array(item);
      }
    }
  });
  var ars = [];
  for (var _i = 0, _Object$entries = Object.entries(groups); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    ars.push(_defineProperty({}, key, _toConsumableArray(value)));
  }
  return ars;
};
//Filter array by filtertags for assignment types
var filterArray = function filterArray(arr, data) {
  var tempArr = arr;
  //retrive all meetings if filter is active
  if (!(data !== null && data !== void 0 && data.Meeting)) {
    var bookedMeetings = tempArr.filter(function (item) {
      return item.type !== "MEETING";
    });
    tempArr = bookedMeetings;
  }
  if (!(data !== null && data !== void 0 && data.Lesson)) {
    var noLessons = tempArr.filter(function (item) {
      return item.type !== "LESSON";
    });
    tempArr = noLessons;
  }
  if (!data.Assignment) {
    var noAssigments = tempArr.filter(function (item) {
      return item.type !== "ASSIGNMENT";
    });
    tempArr = noAssigments;
  }
  if (!data.CalendarEvent) {
    var noCalendarEvents = tempArr.filter(function (item) {
      return item.type !== "CALENDAR_EVENT";
    });
    tempArr = noCalendarEvents;
  }
  return tempArr;
};
var setLocalizer = function setLocalizer() {
  moment.locale(getActiveLanguage());
  return momentLocalizer(moment);
};
var ScheduleView = function ScheduleView(props) {
  var _props$view2;
  var dispatch = useDispatch();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    activeLesson = _useState4[0],
    setActiveLesson = _useState4[1];
  var activeStudent = useSelector(function (state) {
    return state.User.activeStudent;
  });
  var scheduleItems = useSelector(function (state) {
    return state.guardians.schedule;
  });
  var attendance = useSelector(function (state) {
    return state.attendance.user;
  });
  var ScheduleFilter = useSelector(function (state) {
    return state.ScheduleFilter;
  });
  var translate = getTranslate(useSelector(function (state) {
    return state.Languages.translations;
  }));
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    filterData = _useState6[0],
    setFilterData = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    dataTimeout = _useState8[0],
    setDataTimeout = _useState8[1];
  var localizer = useMemo(function () {
    return setLocalizer();
  }, [getActiveLanguage()]);
  var _eventsFactory = function _eventsFactory() {
    if (props.view === "month") {
      return filterData.map(function (item) {
        for (var _i2 = 0, _Object$entries2 = Object.entries(item); _i2 < _Object$entries2.length; _i2++) {
          var _count;
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
            key = _Object$entries2$_i[0],
            value = _Object$entries2$_i[1];
          var count = void 0;
          if (Array.isArray(value)) {
            count = countActivities(value);
          }
          return {
            id: key,
            title: key.toString(),
            length: (_count = count) !== null && _count !== void 0 ? _count : null,
            start: moment.utc(key).set({
              second: 0,
              millisecond: 0
            }).local().toDate(),
            end: moment.utc(key).set({
              second: 0,
              millisecond: 0
            }).local().add(60, "minutes").toDate()
          };
        }
      });
    }
    return filterData.map(function (item) {
      return {
        id: item.id,
        title: item.title,
        start: moment.utc(item.startTime).set({
          second: 0
        }).local().toDate(),
        end: moment.utc(item.startTime).set({
          second: 0
        }).local().add(item.length, "minutes").toDate()
      };
    });
  };
  //count how many of a given activity exists for month view
  var countActivities = function countActivities(data) {
    var count = {};
    var assignment = 0;
    var meetings = 0;
    var lesson = 0;
    var lessonExaminations = 0;
    var calendarEvent = 0;
    data.forEach(function (element) {
      if (element.type === 'MEETING') {
        meetings++;
      } else if (element.type === 'CALENDAR_EVENT') {
        calendarEvent++;
      } else if (element.instanceType) {
        assignment++;
        count[element.instanceType] = (count[element.instanceType] || 0) + 1;
      } else {
        lesson++;
        if (element.examination) {
          lessonExaminations++;
        }
      }
    });
    count.assignment = assignment;
    count.meetings = meetings;
    count.lesson = lesson;
    count.lessonExaminations = lessonExaminations;
    count.calendarEvent = calendarEvent;
    return count;
  };
  useEffect(function () {
    var handlerActivityFilter = function handlerActivityFilter() {
      if (ScheduleFilter.activitiesFilter) {
        if ((scheduleItems === null || scheduleItems === void 0 ? void 0 : scheduleItems.length) > 0) {
          var filterItems = filterArray(scheduleItems, ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.activitiesFilter);
          if (props.view == "month") {
            setFilterData(filterMonth(filterItems, props.date));
            return;
          }
          setFilterData(filterItems);
          return;
        }
      }
      setFilterData([]);
    };
    handlerActivityFilter();
  }, [ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.activitiesFilter, scheduleItems]);

  //handle selected calender event whenever activelesson state changes 
  useEffect(function () {
    if (!activeLesson) {
      var getActiveEvent = document.querySelector('.rbc-selected');
      if (getActiveEvent) {
        getActiveEvent.classList.toggle('rbc-selected');
        //add a temp class so the selected event can be found again
        getActiveEvent.classList.toggle('deSelected');
      }
    } else if (activeLesson) {
      var findElement = document.querySelector('.deSelected');
      if (findElement) {
        findElement.classList.toggle('rbc-selected');
        findElement.classList.toggle('deSelected');
      }
    }
  }, [activeLesson]);
  var _getEventProps = function _getEventProps(event, start, end, isSelected) {
    var _lesson$relationships;
    var className = "";
    var style = {};
    if (props.view == "month") {
      style.backgroundColor = "transparent";
      style.color = "#fff";
      return;
    }
    var lesson = _getScheduleItem(event.id);
    var attendance = lesson === null || lesson === void 0 ? void 0 : lesson.attendance;
    var hasExamination = false;
    if (props.hasAdvancedCalendar) {
      if ((lesson === null || lesson === void 0 ? void 0 : lesson.instanceType) === 'ASSIGNMENT_TYPE_WRITTEN_TEST' || (lesson === null || lesson === void 0 ? void 0 : lesson.instanceType) === 'ASSIGNMENT_TYPE_VERBAL_TEST' || lesson !== null && lesson !== void 0 && lesson.examination) {
        hasExamination = true;
      }
    }

    //check if lesson has an assignment with a test connected
    if ((lesson === null || lesson === void 0 || (_lesson$relationships = lesson.relationships) === null || _lesson$relationships === void 0 ? void 0 : _lesson$relationships.length) > 0 && props.hasAdvancedCalendar) {
      var findItems = lesson.relationships.filter(function (x) {
        return (x === null || x === void 0 ? void 0 : x.instanceType) === 'ASSIGNMENT_TYPE_WRITTEN_TEST' || (x === null || x === void 0 ? void 0 : x.instanceType) === 'ASSIGNMENT_TYPE_VERBAL_TEST';
      });
      if (findItems.length > 0) {
        hasExamination = true;
      }
    }
    if ((lesson === null || lesson === void 0 ? void 0 : lesson.type) === 'ASSIGNMENT') {
      className += "assignment";
      if (hasExamination && props.hasAdvancedCalendar) {
        className += " hasExamination";
      }
      return {
        className: className,
        style: style
      };
    } else if ((lesson === null || lesson === void 0 ? void 0 : lesson.type) === 'MEETING') {
      className += "meeting";
      return {
        className: className,
        style: style
      };
    } else if ((lesson === null || lesson === void 0 ? void 0 : lesson.type) === 'CALENDAR_EVENT') {
      className += 'calendarEvent';
      return {
        className: className,
        style: style
      };
    }
    if (hasExamination && props.hasAdvancedCalendar) {
      className += " hasExamination";
    }
    if (props !== null && props !== void 0 && props.activeStudent.services.attendance && attendance != null) {
      className += " attendance";
      if (attendance.attendanceType == "PRESENT") {
        if (props.view != "agenda") {
          className += " validAttendance";
        }
      }
      if (attendance.attendanceType.indexOf("VALID") > -1) {
        style.borderLeftColor = "#efc24c";
        if (props.view != "agenda") {
          style.backgroundColor = "#fff6df";
        }
      }
      if (attendance.attendanceType.indexOf("INVALID") > -1) {
        style.borderLeftColor = "#f25252";
        if (props.view != "agenda") {
          style.backgroundColor = "#FDE5E5";
        }
      }
    } else {
      if (props !== null && props !== void 0 && props.activeStudent.services.attendance && lesson != null && lesson.attendanceReported != null) {
        className += " attendance";
        if (props.view != "agenda") {
          style.backgroundColor = "#e8fbf0";
        }
      } else {
        className += " lesson";
      }
    }
    return {
      className: className,
      style: style
    };
  };
  var _getScheduleItem = function _getScheduleItem(id) {
    if (id == null) {
      return null;
    }
    return scheduleItems.find(function (item) {
      return item.id == id;
    });
  };
  var _getStartEndDates = function _getStartEndDates() {
    var _props$view;
    var start,
      end = props.date;
    switch ((_props$view = props.view) !== null && _props$view !== void 0 ? _props$view : "week") {
      case 'agenda':
      case 'day':
        start = moment(props.date).format("YYYY-MM-DD");
        end = moment(props.date).add(1, 'days').format("YYYY-MM-DD");
        break;
      case 'work_week':
        start = moment(props.date).isoWeekday(1).format("YYYY-MM-DD");
        end = moment(props.date).isoWeekday("5").format("YYYY-MM-DD");
        break;
      case "week":
        start = moment(props.date).isoWeekday(1).format("YYYY-MM-DD");
        end = moment(props.date).isoWeekday(7).format("YYYY-MM-DD");
        break;
      case "month":
        start = moment(props.date).startOf("month").set({
          hour: 0,
          minute: 0,
          second: 0
        }).format("YYYY-MM-DD"), end = moment(props.date).endOf("month").set({
          hour: 23,
          minute: 59,
          second: 59
        }).format("YYYY-MM-DD");
        break;
      default:
        break;
    }
    return {
      start: start,
      end: end
    };
  };
  var _getTimeRange = function _getTimeRange() {
    var BASE_START_HOUR = 7; // base visible start
    var BASE_END_HOUR = 17; // base visible end
    var FALLBACK_DURATION_MIN = 45; // fallback duration
    var anchorDate = moment(props.date).local(); // Use props.date as the anchor

    var minMoment = anchorDate.clone().set({
      hour: BASE_START_HOUR,
      minute: 0,
      second: 0,
      millisecond: 0
    });
    var maxMoment = anchorDate.clone().set({
      hour: BASE_END_HOUR,
      minute: 0,
      second: 0,
      millisecond: 0
    });

    // If in day view, restrict to items belonging to the selected day.
    var scopedItems = scheduleItems || [];
    if (props.view === 'day' && props.date && scopedItems.length > 0) {
      var targetDay = moment(props.date).local();
      scopedItems = scopedItems.filter(function (it) {
        return moment.utc(it.startTime).local().isSame(targetDay, 'day');
      });
    }
    if (!scopedItems || scopedItems.length === 0) {
      return {
        min: minMoment.toDate(),
        max: maxMoment.toDate()
      };
    }
    var spans = scopedItems.map(function (item) {
      var start = moment.utc(item.startTime).local();
      var duration = typeof item.length === 'number' && item.length > 0 ? item.length : FALLBACK_DURATION_MIN;
      var end = start.clone().add(duration, 'minutes');
      return {
        start: start,
        end: end
      };
    });

    // Collect start/end minutes-of-day for all spans
    var toMinutes = function toMinutes(m) {
      return m.hours() * 60 + m.minutes();
    };
    if (spans.length > 0) {
      var startMinutesList = spans.map(function (s) {
        return toMinutes(s.start);
      });
      var endMinutesList = spans.map(function (s) {
        return toMinutes(s.end);
      });
      var earliestMinutes = Math.min.apply(Math, _toConsumableArray(startMinutesList));
      var latestMinutes = Math.max.apply(Math, _toConsumableArray(endMinutesList));
      var startThreshold = BASE_START_HOUR * 60; // 07:00
      var endThreshold = BASE_END_HOUR * 60; // 17:00

      // Adjust min (snap to hour for earliest)
      if (earliestMinutes < startThreshold) {
        minMoment = minMoment.clone().set({
          hour: Math.floor(earliestMinutes / 60),
          minute: 0,
          second: 0,
          millisecond: 0
        });
      }

      // Adjust max (snap forward to next half-hour if needed)
      if (latestMinutes >= endThreshold) {
        // Add a margin and round up to the next full hour
        var extendedMinutes = latestMinutes + 60;
        var finalHour = Math.ceil(extendedMinutes / 60);
        var finalMinute = 0;

        // Safeguard: Prevent hour from exceeding 23, which causes date rollover
        if (finalHour > 23) {
          finalHour = 23;
          finalMinute = 59; // Set to the very end of the day
        }
        maxMoment = maxMoment.clone().set({
          hour: finalHour,
          minute: finalMinute,
          second: 0,
          millisecond: 0
        });
      }
    }
    return {
      min: minMoment.toDate(),
      max: maxMoment.toDate()
    };
  };
  var onSelectEvent = function onSelectEvent(slot) {
    var lesson = _getScheduleItem(slot.id);
    if (lesson == null) {
      return false;
    }
    setActiveLesson(lesson);
  };
  var renderEventTitle = function renderEventTitle(event) {
    var lesson = _getScheduleItem(event.id);
    var attendance = lesson === null || lesson === void 0 ? void 0 : lesson.attendance;
    return /*#__PURE__*/React.createElement(ItemContent, {
      services: props === null || props === void 0 ? void 0 : props.activeStudent.services,
      lesson: lesson,
      event: event,
      attendance: attendance,
      view: props.view
    });
  };
  useEffect(function () {
    var _getStartEndDates2 = _getStartEndDates(),
      start = _getStartEndDates2.start,
      end = _getStartEndDates2.end;
    var startTime = moment(start).startOf("day").format("YYYY-MM-DDTHH:mm:ss");
    var endTime = moment(end).endOf("day").format("YYYY-MM-DDTHH:mm:ss");

    // Prevent unnecessary dispatches when user rapidly clicks next multiple times
    if (dataTimeout != null) {
      clearTimeout(dataTimeout);
    }
    setDataTimeout(setTimeout(function () {
      setIsLoading(true);
      props.setScheduleLoading(true);
      Promise.all([dispatch(getGuardianStudentSchedule(activeStudent.id, start, end))]).then(function () {
        setIsLoading(false);
        props.setScheduleLoading(false);
      });
    }, 500));
  }, [props.date, props.view]);
  var _getStartEndDates3 = _getStartEndDates(),
    start = _getStartEndDates3.start,
    end = _getStartEndDates3.end;
  var _getTimeRange2 = _getTimeRange(),
    min = _getTimeRange2.min,
    max = _getTimeRange2.max;
  return /*#__PURE__*/React.createElement("div", {
    className: "c--schedule"
  }, activeLesson != null ? /*#__PURE__*/React.createElement(Modal, {
    title: activeLesson.type == "ASSIGNMENT" ? translate("Assignment") : activeLesson.type === "MEETING" ? translate("Meeting") : activeLesson.type === "CALENDAR_EVENT" ? translate("Calendar event") : translate("Lesson"),
    isOpen: true,
    overridePrompt: true,
    onClose: function onClose() {
      return setActiveLesson(null);
    }
  }, /*#__PURE__*/React.createElement(SingleModalLesson, {
    activeLesson: activeLesson,
    onAbort: function onAbort() {
      return setActiveLesson(null);
    }
  })) : null, /*#__PURE__*/React.createElement(SelectionDisplay, {
    start: start,
    end: end,
    isLoading: isLoading,
    view: props.view
  }), /*#__PURE__*/React.createElement(Calendar, {
    localizer: localizer,
    events: _eventsFactory(),
    eventPropGetter: _getEventProps,
    startAccessor: "start",
    endAccessor: "end",
    date: props.date != null ? props.date.toDate() : moment().toDate(),
    view: (_props$view2 = props.view) !== null && _props$view2 !== void 0 ? _props$view2 : "work_week",
    views: ["work_week", "week", "day", "month", "agenda"],
    toolbar: false,
    min: min,
    max: max,
    formats: props.view == "month" ? formats : {
      dayFormat: function dayFormat(date, culture, localizer) {
        return localizer.format(date, "dddd D/M", culture).capitalize();
      }
    },
    messages: {
      noEventsInRange: /*#__PURE__*/React.createElement("span", {
        style: {
          display: "block"
        },
        className: "color--meta text--center weight--bold"
      }, translate("No schedule for today"))
    },
    titleAccessor: renderEventTitle,
    onSelectEvent: onSelectEvent,
    components: {
      month: {
        header: MonthHeader
      }
    },
    onView: function onView() {
      return true;
    },
    onNavigate: function onNavigate() {
      return true;
    }
  }));
};
export default ScheduleView;